module.exports = __webpack_public_path__ + "media/images/mailer/cake-48-primary-58b391d1d86ea2fd458bc10b93ea6015.png";